// carousel_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["item"];
  static values = {
    interval: { type: Number, default: 3000 },
  };

  connect() {
    this.currentIndex = 0;
    this.startCarousel();
  }

  disconnect() {
    this.stopCarousel();
  }

  startCarousel() {
    this.stopCarousel();

    if (this.hasItemTarget) {
      this.intervalId = setInterval(() => {
        this.showNext();
      }, this.intervalValue);
    }
  }

  stopCarousel() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  showNext() {
    // Hide current item
    this.itemTargets[this.currentIndex].classList.remove("active");

    // Move to next item
    this.currentIndex = (this.currentIndex + 1) % this.itemTargets.length;

    // Show new item
    this.itemTargets[this.currentIndex].classList.add("active");
  }
}
